import * as React from 'react'

export default () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.7627 8.37988C18.4455 8.38011 19.8096 9.74485 19.8096 11.4277V12.9521L27.4277 9.90527V22.0947L19.8096 19.0479V20.5703C19.8093 22.253 18.4454 23.617 16.7627 23.6172H7.62012C5.93724 23.6172 4.5725 22.2531 4.57227 20.5703V11.4277C4.57227 9.74471 5.93709 8.37988 7.62012 8.37988H16.7627Z"
      fill="#8FB4FF"
    />
  </svg>
)
